export const ORDER_URL =
  "https://www.bulgarche2018.bg/%D0%BF%D0%B0%D1%80%D1%82%D0%B8-%D0%BA%D0%BB%D1%83%D0%B1";
export const INSTAGRAM_URL =
  "https://www.instagram.com/b1b2.agency?stkn=MWZqNGJxOHp1M28wZw%3D%3D&utm_source=qr";
export const EMAIL = "b1xb2agency@gmail.com";
export const PHONE = "+359 883 44 66 47";
export const PHONE_HREF = "tel:+359883446647";

export const HERO_IMG = "/images/hero-table.jpeg";
export const ABOUT_IMG = "/images/about-team.jpeg";

export const NAV_LINKS = [
  { id: "home", label: "Начало" },
  { id: "about", label: "За B1 & B2" },
  { id: "party", label: "Party комбинации" },
  { id: "extras", label: "Допълнителни предложения" },
  { id: "sweet", label: "Сладки предложения" },
  { id: "how", label: "Как да поръчате" },
];

export const STEPS = [
  {
    num: "01",
    title: "Изберете",
    text: "Изберете PARTY комбинация.",
  },
  {
    num: "02",
    title: "Допълнете",
    text: "Добавете допълнителни или сладки предложения.",
  },
  {
    num: "03",
    title: "Заявете",
    text: "Изпратете цялата заявка към „Българче“.",
  },
];

const KROASAN = "Мини кроасан със салам Милано и Гауда";
const CAPREZE = "Мини салата Капрезе с чери домати, босилек и бейби моцарела";
const TORTILA = "Тортиля с жарено филе, Ементал, салатки и балсамова редукция";
const TARTALETA = "Тарталета с прошуто и ананас";
const BONBON = "Солен бонбон с различни сирена, овалян в натрошени ядки";
const BRUSKETA = "Брускета с крем мус от раци и лайм";

export const PARTY_PACKS = [
  {
    id: "10",
    name: "PARTY 10",
    meta: "40 хапки | ≈ 1,20 кг",
    price: "45",
    img: "/images/kroasan.webp",
    alt: "Мини кроасани със салам Милано и Гауда от PARTY 10",
    items: [KROASAN, CAPREZE, TORTILA, TARTALETA],
    count: 10,
  },
  {
    id: "15",
    name: "PARTY 15",
    meta: "60 хапки | ≈ 1,80 кг",
    price: "65",
    img: "/images/bonbon-card.jpeg",
    alt: "Солени бонбони със сирена, оваляни в натрошени ядки от PARTY 15",
    items: [BONBON, TORTILA, TARTALETA, KROASAN, CAPREZE],
    count: 12,
  },
  {
    id: "20",
    name: "PARTY 20",
    meta: "90 хапки | ≈ 2,70 кг",
    price: "85",
    img: "/images/brusketa.jpeg",
    alt: "Брускети с крем мус от раци и лайм от PARTY 20",
    items: [BRUSKETA, BONBON, TORTILA, TARTALETA, KROASAN, CAPREZE],
    count: 15,
  },
];

export const ITEM_VARIANTS = {
  [KROASAN]: [
    "/images/kroasan.webp",
    "/images/kroasan-close.jpeg",
    "/images/kroasan-wide.webp",
  ],
  [CAPREZE]: [
    "/images/caprese.webp",
    "/images/caprese-close.jpeg",
    "/images/caprese-stand.jpeg",
  ],
  [TORTILA]: [
    "/images/tortilla.webp",
    "/images/tortila-close.webp",
    "/images/tortila-wide.webp",
  ],
  [TARTALETA]: [
    "/images/tartaleta.webp",
    "/images/tartaleta-close.webp",
    "/images/tartaleta-wide.webp",
  ],
  [BONBON]: [
    "/images/bonbon-tight.jpeg",
    "/images/bonbon-wide2.jpeg",
    "/images/bonbon-card.jpeg",
  ],
  [BRUSKETA]: [
    "/images/brusketa.jpeg",
    "/images/brusketa-close.jpeg",
    "/images/brusketa-platter.webp",
  ],
};

export const SAVOURY = [
  {
    name: "Мини Smash бургер с телешко и свинско кюфте, разтопен чедър, салатки и бургер сос",
    qty: "20 бр.",
    price: "48",
    img: "/images/burger-table.jpeg",
    gallery: [
      "/images/burger-table.jpeg",
      "/images/smash-burger.jpeg",
    ],
    pos: "65% 85%",
    alt: "Мини Smash бургери върху елегантна маса",
  },
  {
    name: CAPREZE,
    qty: "20 бр.",
    price: "18",
    img: "/images/caprese-close.jpeg",
    gallery: ITEM_VARIANTS[CAPREZE],
    alt: "Мини салата Капрезе",
  },
  {
    name: "Солен мъфин с маслини и риган",
    qty: "20 бр.",
    price: "20",
    img: "/images/mufin-maslini-close.jpeg",
    gallery: [
      "/images/mufin-maslini-close.jpeg",
      "/images/mufin-maslini.jpeg",
    ],
    alt: "Солен мъфин с маслини и риган, разрязан",
  },
  {
    name: TORTILA,
    qty: "20 бр.",
    price: "48",
    img: "/images/tortila-close.webp",
    gallery: ITEM_VARIANTS[TORTILA],
    alt: "Тортиля с жарено филе",
  },
  {
    name: "Мини банички с масло и сирене",
    qty: "Около 600 грама",
    price: "14",
    img: "/images/banichki.jpeg",
    gallery: [
      "/images/banichki.jpeg",
      "/images/banichki-2.jpeg",
      "/images/banichki-close.jpeg",
    ],
    alt: "Мини банички с масло и сирене",
  },
  {
    name: KROASAN,
    qty: "20 бр.",
    price: "28",
    img: "/images/kroasan-close.jpeg",
    gallery: ITEM_VARIANTS[KROASAN],
    alt: "Мини кроасан със салам Милано",
  },
  {
    name: "Ориенталски еклер с хумус и пипер",
    qty: "20 бр.",
    price: "17",
    img: "/images/ekler-close-1.jpg",
    gallery: ["/images/ekler-close-1.jpg", "/images/ekler-close-2.jpg"],
    alt: "Ориенталски еклер с хумус и пипер",
  },
  {
    name: BONBON,
    qty: "20 бр.",
    price: "22",
    img: "/images/bonbon-tight.jpeg",
    gallery: ITEM_VARIANTS[BONBON],
    alt: "Солен бонбон със сирена",
  },
  {
    name: "Солен мъфин с шунка и моцарела",
    qty: "20 бр.",
    price: "20",
    img: "/images/mufin-shunka.jpeg",
    alt: "Солен мъфин с шунка и моцарела",
  },
  {
    name: BRUSKETA,
    qty: "20 бр.",
    price: "24",
    img: "/images/brusketa-close.jpeg",
    gallery: ITEM_VARIANTS[BRUSKETA],
    alt: "Брускета с крем мус от раци и лайм",
  },
  {
    name: TARTALETA,
    qty: "20 бр.",
    price: "24",
    img: "/images/tartaleta-close.webp",
    gallery: ITEM_VARIANTS[TARTALETA],
    alt: "Тарталета с прошуто и ананас",
  },
];

export const SWEET = [
  {
    name: "Тарталети с домашен крем с пресни плодове",
    qty: "20 бр.",
    price: "22",
    img: "/images/sl-tartaleti.jpeg",
    gallery: [
      "/images/sl-tartaleti.jpeg",
      "/images/sl-tartaleti-stand.webp",
      "/images/sl-tartaleti-close.jpeg",
      "/images/sl-tartaleti-close2.webp",
      "/images/sl-tartaleti-platter.jpeg",
    ],
    alt: "Тарталети с домашен крем и пресни плодове",
  },
  {
    name: "Сладки мъфини с шоколад",
    qty: "20 бр.",
    price: "20",
    img: "/images/sl-mufini-shokolad.jpeg",
    gallery: [
      "/images/sl-mufini-shokolad.jpeg",
      "/images/sl-mufini-shokolad-2.jpeg",
      "/images/sl-mufini-shokolad-3.jpeg",
    ],
    alt: "Сладки мъфини с шоколад",
  },
  {
    name: "Сладки плодови мъфини",
    qty: "20 бр.",
    price: "20",
    img: "/images/sl-mufini-plodovi-2.jpeg",
    gallery: [
      "/images/sl-mufini-plodovi-2.jpeg",
      "/images/sl-mufini-plodovi-3.jpeg",
      "/images/sl-mufini-plodovi.jpeg",
    ],
    alt: "Сладки плодови мъфини",
  },
  {
    name: "Шоко еклер с мус от течен шоколад",
    qty: "20 бр.",
    price: "20",
    img: "/images/sl-banichki-yabulki.jpeg",
    gallery: ["/images/sl-banichki-yabulki.jpeg", "/images/sl-ekler-2.webp"],
    alt: "Шоко еклер с мус от течен шоколад",
  },
];
